import apiClient from '@/api/client'
export default class AuthAPI {

    // User Login API
    static login(payload: { email: string | undefined; password: string | undefined }) {
        return apiClient.post('/admin/login', payload)
    }

    static logout() {
        return apiClient.post('/admin/logout').then(() => {
            delete apiClient.defaults.headers.Authorization
        })
    }

    static forgetPassword(payload: { email: string | undefined }) {
        return apiClient.post('/admin/forget-password', payload)
    }

    static resetPassword(payload: { token: string | null; new_password: string | undefined }) {
        return apiClient.post('/admin/reset-password', payload)
    }
    static loginAsOrganization(payload: { email: string | undefined; _id: string | undefined }) {
        return apiClient.post('/admin/login-as-organization', payload)
    }
}
